export default __webpack_public_path__ + "static/media/Pick-up-2.f23b793c.svg";